import { render, staticRenderFns } from "./OrganisationExtracts.vue?vue&type=template&id=4f078fd6&"
import script from "./OrganisationExtracts.vue?vue&type=script&lang=js&"
export * from "./OrganisationExtracts.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationExtracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports